/* COMBO PRIME KORVEN - CTA, ofertas 1/2 combos conectadas a ReleasIt, selector de color, videos automáticos y barra fija.
   Checkout real = botón de ReleasIt (#_rsi-buy-now-button-overwrite, no iframe).
   Ofertas = ._rsi-quantity-offers-offer-container[data-offer-pos="0|1"] dentro de #_rsi-cod-form-modal. */
(function () {
  if (window.__pkInit) return;
  window.__pkInit = true;

  function visible(el) { var r = el && el.getBoundingClientRect(); return !!(r && r.width > 0 && r.height > 0); }
  function realButton() {
    var sels = ['.pk-hero #_rsi-buy-now-button-overwrite', '#rsi-button-hook #rsi_buy_now_button', '.pk-hero #_rsi-buy-now-button', '.product-form__buttons #_rsi-buy-now-button', '#_rsi-buy-now-button', '#rsi_buy_now_button'];
    for (var i = 0; i < sels.length; i++) {
      var list = [].slice.call(document.querySelectorAll(sels[i]));
      var v = list.filter(function (b) { return visible(b) && !b.closest('#_rsi-buy-now-button-floating'); })[0] || list.filter(visible)[0];
      if (v) return v;
    }
    return document.querySelector('form[action*="/cart/add"] button[type="submit"][name="add"]:not([disabled])');
  }

  /* ---------- ofertas (1 combo / 2 combos) ---------- */
  var current = '1';
  function cards() { return [].slice.call(document.querySelectorAll('.pk-opt[data-pack]')); }
  function paint(pack) {
    current = String(pack);
    cards().forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-pack') === current ? 'true' : 'false'); });
  }
  var want = null, until = 0, obs = null, guard = false;
  function rowFor(pos) {
    var m = document.getElementById('_rsi-cod-form-modal');
    if (!m) return null;
    return m.querySelector('._rsi-quantity-offers-offer-container[data-offer-pos="' + pos + '"]') ||
      [].slice.call(m.querySelectorAll('._rsi-quantity-offers-offer-container'))[pos] || null;
  }
  function enforce() {
    if (want === null || Date.now() > until || guard) return;
    var row = rowFor(want);
    if (!row || row.classList.contains('_rsi-quantity-offers-selected')) return;
    guard = true;
    var inner = row.querySelector('._rsi-quantity-offers-offer') || row;
    inner.click();
    if (!row.classList.contains('_rsi-quantity-offers-selected')) row.click();
    setTimeout(function () { guard = false; }, 60);
  }
  function selectInForm(pack) {
    /* también fuerza la oferta 1 (pos 0): ReleasIt recuerda la última oferta elegida al reabrir */
    want = Math.max(0, Number(pack) - 1);
    until = Date.now() + 4000;
    var m = document.getElementById('_rsi-cod-form-modal');
    if (m && !obs && window.MutationObserver) {
      obs = new MutationObserver(enforce);
      obs.observe(m, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }
    (function poll() { enforce(); if (Date.now() < until) setTimeout(poll, 150); })();
  }
  /* si la persona cambia de oferta a mano dentro del formulario, se respeta su elección */
  document.addEventListener('click', function (ev) {
    if (ev.isTrusted && ev.target.closest && ev.target.closest('#_rsi-cod-form-modal ._rsi-quantity-offers-offer-container')) { want = null; }
  }, true);

  document.addEventListener('click', function (ev) {
    /* 1) Los botones CTA siempre ganan (aunque vivan dentro de una tarjeta) */
    var t = ev.target.closest && ev.target.closest('[data-pk-cta]');
    if (t) {
      ev.preventDefault();
      var p = t.getAttribute('data-pk-pack');
      if (p) paint(p);
      var pack = p || current;
      var box = document.querySelector('[id^="MainProduct-"]');
      if (box) box.scrollIntoView({ behavior: 'instant', block: 'start' }); else window.scrollTo({ top: 0, behavior: 'instant' });
      setTimeout(function () { var b = realButton(); if (b) { b.click(); selectInForm(pack); } }, 400);
      return;
    }
    /* 2) Clic directo en el botón real de ReleasIt del hero: abre con la oferta elegida */
    var rb = ev.target.closest && ev.target.closest('.pk-hero #_rsi-buy-now-button-overwrite, .pk-hero #_rsi-buy-now-button');
    if (rb) { selectInForm(current); return; }
    /* 3) Tarjeta de oferta: solo selecciona */
    var opt = ev.target.closest && ev.target.closest('.pk-opt[data-pack]');
    if (opt) { ev.preventDefault(); paint(opt.getAttribute('data-pack')); }
  });

  /* ---------- botón de ReleasIt con forma del tema ---------- */
  function skinButton() {
    [].forEach.call(document.querySelectorAll('.pk-hero ._rsi-buy-now-button'), function (b) { b.style.setProperty('border-radius', '8px', 'important'); });
  }
  var tries = 0;
  (function loop() { skinButton(); if (tries++ < 20) setTimeout(loop, 500); })();

  /* ---------- selector de color: punto de color + nombre elegido ---------- */
  var HEX = { 'negro': '#1b1b1b', 'café': '#5a3825', 'cafe': '#5a3825', 'miel': '#b9803f', 'azul': '#1d2c4a', 'azul oscuro': '#1d2c4a' };
  function colorUI() {
    [].forEach.call(document.querySelectorAll('.pk-hero .product-form__input--pill'), function (fs) {
      [].forEach.call(fs.querySelectorAll('input[type="radio"]'), function (inp) {
        var lab = fs.querySelector('label[for="' + inp.id + '"]');
        if (!lab || lab.querySelector('.pk-dot')) return;
        var hex = HEX[(inp.value || '').trim().toLowerCase()];
        if (!hex) return;
        var d = document.createElement('i'); d.className = 'pk-dot'; d.style.background = hex;
        lab.insertBefore(d, lab.firstChild);
      });
      var lg = fs.querySelector('legend'), on = fs.querySelector('input[type="radio"]:checked');
      if (lg && on) {
        var base = (lg.getAttribute('data-pk-base') || lg.textContent.replace(/:.*$/, '')).trim();
        lg.setAttribute('data-pk-base', base);
        lg.innerHTML = base + ': <span class="pk-legend-val">' + on.value.replace(/</g, '&lt;') + '</span>';
      }
    });
  }
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('.pk-hero variant-selects')) { setTimeout(colorUI, 60); setTimeout(colorUI, 500); }
  });

  /* ---------- videos: se reproducen solos al llegar y se pausan al salir ---------- */
  function setupVideos() {
    var vids = [].slice.call(document.querySelectorAll('.pk-vids video'));
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { if (!v.__pkIo) { v.__pkIo = true; io.observe(v); } });
  }

  /* ---------- barra fija ---------- */
  function inView(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function stickyCheck() {
    var s = document.querySelector('.pk-sticky');
    if (!s) return;
    var box = document.querySelector('[data-pk-buybox]');
    var past = box ? box.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var inEnd = [].slice.call(document.querySelectorAll('[data-pk-close]')).some(inView);
    s.classList.toggle('show', past && !inEnd);
  }
  window.addEventListener('scroll', stickyCheck, { passive: true });

  function init() {
    colorUI(); setTimeout(colorUI, 800);
    paint('1');
    setupVideos();
    stickyCheck();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
